export default __webpack_public_path__ + "static/media/accretivetraining.c6e977cb.jpg";